import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typist from 'react-typist';
import { media } from 'styles';
import { colors, sp } from 'styles/theme';
import mixins from 'styles/mixins';

const HeroText = styled.div`
  ${mixins.heroText};
  margin-bottom: ${sp.xl};

  h1 {
    font-size: inherit;
  }
`;

const StyledTypist = styled(Typist)`
  display: inline-block;
  color: ${colors.royal};
  text-transform: lowercase;
  border-bottom: 3px solid ${colors.border};
  padding-bottom: ${sp.s};

  ${props =>
    props.light &&
    `
    color: rgba(255, 255, 255, 0.7);
    border-bottom: 3px solid rgba(255, 255, 255, 0.4);
    font-size: 40px;
    line-height: 48px;
  `} ${media.tablet`
    ${props =>
      props.light &&
      `
      font-size: 48px;
      line-height: 58px;
    `}
  `};

  .Cursor {
    display: inline-block;

    ${props =>
      props.light &&
      `
      color: ${colors.blue};
    `} &--blinking {
      opacity: 1;
      animation: blink 1s linear infinite;
      @keyframes blink {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    }
  }
`;

export default class TypingHero extends React.Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    lines: PropTypes.arrayOf(PropTypes.string).isRequired,
    light: PropTypes.bool.isRequired,
  };

  state = { lineIdx: 0 };

  typeNextLine = () => {
    const { lineIdx } = this.state;
    let nextIdx = lineIdx + 1;
    if (nextIdx === this.props.lines.length) nextIdx = 0;
    this.setState({ lineIdx: nextIdx });
  };

  render() {
    const { heading, lines, light } = this.props;
    const line = lines[this.state.lineIdx];

    return (
      <HeroText>
        <h1>{heading}</h1>
        <StyledTypist key={line} onTypingDone={this.typeNextLine} light={light}>
          {line}
          <Typist.Backspace count={line.length} delay={1000} />
          <Typist.Delay ms={1000} />
        </StyledTypist>
      </HeroText>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/TypingHero/TypingHero.jsx